<div class="user-avatar-container">
  <i class="icon-user" [class.light-background]="lightBackground">
    @if (profilePicture) {
      <img [src]="profilePicture" lhLoadStatus />
    }
  </i>
  @if (notificationCount > 0) {
    <div class="notification-badge">
      <div class="notification-count">{{ notificationCount }}</div>
    </div>
  }
</div>
